import React, { useState, useContext } from 'react';
import Layout from "components/Layout";
import FormRegister from 'components/FormRegister';
import FormVerification from 'components/FormVerification';
import FormResendCode from 'components/FormResendCode';
import LoginService from 'services/Login/service';
import SessionFactory from 'factories/Session';
import { AuthContext } from '../../auth/AuthContext';
import { types } from '../../types/types';
import FormRegisterSocial from 'components/FormRegisterSocial';

const Register = () => {

    const { sessionDispatch } = useContext(AuthContext);
    const [formProcess, setFormProcess] = useState(1);
    const [formData, setFormData] = useState({});
   //erick
    const [formRegisterVisible,setFormRegisterVisible]= useState(false);
    const [formRegisterSocialVisible,setFormRegisterSocialVisible]= useState(false);
    const [documentData,setDocumentData]=useState({});
    const [legalRegister,setLegalRegister]=useState({});


    const visibleForm = ()=>{
        setFormRegisterVisible(!formRegisterVisible);
        setFormRegisterSocialVisible(false);
    }
    const visibleFormSocial = ()=>{
        //visible FormRegister
        setFormRegisterSocialVisible(!formRegisterSocialVisible);
        setFormRegisterVisible(false);
    }
    
  
    const changeFormProcess = (nextStep, data,legal,document) => {
        setFormProcess(nextStep);
        setFormData(data);
        setLegalRegister(legal);
        setDocumentData(document);
    
    } 
    const closeFormSocial=()=>{
        setFormRegisterSocialVisible(false);
    }
    const processConfirmation = async (tokenData = '', onSuccess = null, onError = null) => {
        try{
            //confirm register - vtex
            const payload_reg = {
                'user': formData.user,
                'token': tokenData
            };
            const auth_reg = await LoginService.authConfirmRegister(payload_reg);
            if(!auth_reg || (auth_reg && !auth_reg.payload) || (auth_reg && auth_reg.internalCode!=='200')){
                onError && onError();
                return;
            }
            //login application
            Promise.all([LoginService.authTokenCoupons({
               
                'jwt': auth_reg.payload.tokenJwt,
                'originWeb': 1,
                'termConditions': legalRegister.termConditionsChecked ? 1 : 0,
                'privacyPolicies': legalRegister.privacyPoliciesChecked ? 1 : 0,
                'legalOthers': legalRegister.legalOthersChecked ? 1 : 0,
                'documentCode':documentData.additionalData.documentCode,
                'documentNumber':documentData.additionalData.documentNumber,
                'sessionType':"register"
            
            })]).then(auth => {
                if(!auth || (auth && !['200','201'].includes(auth[0].internalCode))){
                    onError && onError();
                    return;
                }
                onSuccess && onSuccess();
                sessionDispatch({
                    type: types.login,
                    payload: SessionFactory.initialize(auth[0].payload)
                });
            });
        }catch(error){
            console.error(error);
            onError && onError();
        }
    }

    return (
        <div className={formProcess===1?"register":"register-step-2"}>
            <Layout showBanner={false}>
                {formProcess===1
                    ?
                    <section className="authentication">
                        <div className="container">
                            <div className="row">
                                <div className="col-12 col-lg-10 ml-lg-auto mr-lg-auto">
                                    <div className="row">
                                        <div className="col-12">
                                            <h2 className="text-center red mt-4 mb-4">Crear una cuenta</h2>
                                            <p className="text-center mt-4 red-dark">Puedes ingresar con tu cuenta de Metro.pe</p>
                                            <div className="col-12 col-lg-5 ml-lg-auto mr-lg-auto mt-lg-3 mt-4">
                                            <button  className=" btn btn-conect-social-ingresar mt-3 btn-default btn-sm no-hover hover-metro btn-block" onClick={visibleFormSocial}
                                                disabled={false}>Registrarse con Google
                                            </button>
                                            <br/>
                                            {formRegisterSocialVisible ? (
                                            <div>
                                              <FormRegisterSocial closeFormRegisterSocial={closeFormSocial}/>
                                             </div>
                                            
                                            ) : (
                                              <div>
                                              {/* Contenido para formRegisterSocialVisible cuando es falso */}
                                              </div>
                                            )}
                                            <button  className=" btn btn-conect-social-ingresar mt-3 btn-default btn-sm no-hover hover-wong btn-block" onClick={visibleForm}
                                                disabled={false}>Registrarse con Email y Contraseña</button>
                                            </div>
                                            {
                                            formRegisterVisible?
                                                <div className="col-12 col-lg-6 ml-lg-auto mr-lg-auto mt-lg-5 mt-3 d-lg-flex flex-lg-column justify-content-lg-center">
                                                <FormRegister processData={changeFormProcess}  />
                                                </div>
                                            :
                                            <div className="col-12 col-lg-8 ml-lg-auto mr-lg-auto mt-lg-4 mt-3">

                                              

                                            </div>
                                            }
                                        </div> 
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    :
                    (formProcess===2
                        &&
                        <section className="authentication">
                            <div className="container">
                                <div className="row">
                                    <div className="col-12 col-lg-10 ml-lg-auto mr-lg-auto">
                                        <div className="row">
                                            <div className="col-12">
                                                <h2 className="text-center red mt-4 mb-4">Registro</h2>
                                            </div>
                                            <div className="col-12 col-lg-6 col-xl-6 form form-1-column d-lg-flex flex-lg-column justify-content-lg-center ml-lg-auto mr-lg-auto">
                                                <FormVerification userEmail={formData && formData.email} externalSubmit={processConfirmation}/>
                                            </div>
                                        </div>
                                        <div className="row footer-links">
                                            <div className="col-12 col-lg-4 ml-lg-auto mr-lg-auto mt-lg-5 mt-3">
                                                <FormResendCode userEmail={formData && formData.user} isRegister={true}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    )
                }
            </Layout>
        </div>
    )
    
};
export default Register;
